// Client-side downscale before upload. 1600px on the long side is enough to read a slab
// label and even a PSA cert barcode (proved across 213 bursts in the batch pipeline), and
// keeps two photographs at roughly 1MB total.
export function fitWithin(w: number, h: number, max: number): { w: number; h: number } {
  const scale = Math.min(1, max / Math.max(w, h));
  return { w: Math.round(w * scale), h: Math.round(h * scale) };
}

export async function downscaleToJpeg(file: File, max = 1600): Promise<{ b64: string; w: number; h: number; bytes: number }> {
  const bitmap = await createImageBitmap(file);
  const { w, h } = fitWithin(bitmap.width, bitmap.height, max);
  const canvas = document.createElement("canvas");
  canvas.width = w; canvas.height = h;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("this browser cannot resize images");
  ctx.drawImage(bitmap, 0, 0, w, h);
  bitmap.close?.();
  const dataUrl = canvas.toDataURL("image/jpeg", 0.9);
  const b64 = dataUrl.split(",")[1] ?? "";
  if (!b64) throw new Error("the photo could not be read");
  const bytes = Math.round((b64.length * 3) / 4);
  if (Math.max(w, h) < 600) throw new Error("that photo is too small — fill the frame with the card");
  return { b64, w, h, bytes };
}
